export default __webpack_public_path__ + "static/media/trafficlight.f366322f.svg";